import type { ReactNode } from 'react';

import { cn } from '@repo/videa-components/src/lib/utils';

const BASE_CLASSES =
  'vai-flex vai-flex-shrink-0 vai-w-full vai-pt-4 vai-pb-4 vai-px-1 vai-bg-background';

export interface SheetFooterProps {
  children: ReactNode;
  className?: string;
}

/**
 * Reusable sticky footer for sheet views (e.g. VideaNotes).
 * Use for consent + buttons, recording controls, or result action bars.
 */
export const SheetFooter = ({ children, className }: SheetFooterProps) => (
  <footer className={cn(BASE_CLASSES, className)} data-testid="sheet-footer">
    {children}
  </footer>
);
